module.exports = __webpack_public_path__ + "static/media/Arizonia-Regular.c3fc737c.ttf";